import React from "react";
import {Switch, Route} from "react-router-dom";

import Welcome from "./pages/welcome/Welcome";
import DeceasedDetails from "./pages/deceased-details/DeceasedDetails";
import MatchResult from "./pages/match-result/MatchResult";
import YourDetails from "./pages/your-details/YourDetails";
import Confirm from "./pages/confirm/Confirm";
import Finished from "./pages/finished/Finished";

function App() {
  return (
    <Switch>
      <Route path="/" exact component={Welcome}/>
      <Route path="/welcome" exact component={Welcome}/>
      <Route path="/deceased-details" exact component={DeceasedDetails}/>
      <Route path="/your-details" exact component={YourDetails}/>
      <Route path="/match-result" exact component={MatchResult}/>
      <Route path="/confirm" exact component={Confirm}/>
      <Route path="/finished" exact component={Finished}/>
    </Switch>
  );
}

export default App;
